import { InjectionToken } from '@angular/core';

import { Widgets } from './widget.model';

export const CMPS_WIDGET_WIDGETS = new InjectionToken<Widgets[]>(
    'CMPS_WIDGETS',
);
export const CMPS_WIDGET_COMPONENT_CONFIG = new InjectionToken(
    'CMPS_WIDGET_COMPONENT_CONFIG',
);
export const CMPS_WIDGET_CONFIG = new InjectionToken('CMPS_WIDGET_CONFIG');
export const CMPS_WIDGET_OPTIONS = new InjectionToken('CMPS_WIDGET_OPTIONS');
